export default "__VITE_ASSET__BKpfQ9VC__"